import { render, staticRenderFns } from "./Gyfy.vue?vue&type=template&id=0e01ef0c&scoped=true&"
import script from "./Gyfy.vue?vue&type=script&lang=js&"
export * from "./Gyfy.vue?vue&type=script&lang=js&"
import style0 from "./Gyfy.vue?vue&type=style&index=0&id=0e01ef0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e01ef0c",
  null
  
)

export default component.exports